export const container = ({ theme: { colors } }) => ({
    stroke: colors.dividerGrey,
    position: 'absolute',
    height: '12rem',
    overflow: 'hidden',
});
